import _ from "lodash"
import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import withRouter from "components/Common/withRouter"

import {
  Col,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap"
import Select from "react-select"

//Import functions
import { formatPhoneNumber } from "common/global/functions"

const AccessCodeForm = ({
  initialValues,
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  handleSubmit,
  submitForm,
  setFieldValue,
  setFieldTouched,
  setFieldError,
  accessCodeMethods,
  handleAccessCodeSelectChange,
  ...props
}) => {
  
  return (
    <React.Fragment>
      <Form className="form-horizontal" id="residency-information-form">
        <Input
            type="hidden"
            id="key"
            name="key"
            value={values.key || ""}
            invalid={errors.key ? true : false}
        />
        {touched.key && errors.key && (
            <FormFeedback
            className="mb-3"
            type="invalid"
            style={{ fontSize: "100%" }}
            >
            {errors.key}
            </FormFeedback>
        )}
        <Row>
        <Col lg="6">
            <FormGroup className="mb-3">
            <Label for="access_code_method">
            Verification options
                </Label>
                <Select
                id="access_code_method"
                name="access_code_method"
                placeholder="Select Access Code Method"
                defaultValue={
                    values.access_code_method
                }
                onChange={selectedOption => {
                    let event = {
                    target: {
                        name: "access_code_method",
                        option: selectedOption,
                    },
                    }
                    handleAccessCodeSelectChange(event)
                }}
                isSearchable={true}
                options={accessCodeMethods()}
                isLoading={false}
                loadingMessage={() =>
                    "loading access code types"
                }
                noOptionsMessage={() => "access_code_method"}
                invalid={
                    touched.access_code_method &&
                    errors.access_code_method &&
                    errors.access_code_method.value
                    ? true
                    : false
                }
                />
                {touched.access_code_method &&
                errors.access_code_method &&
                errors.access_code_method.value && (
                <FormFeedback
                    type="invalid"
                    style={{
                    display: "block",
                    fontSize: "100%",
                    }}
                >
                    {errors.access_code_method.value}
                </FormFeedback>
                )}
            </FormGroup>
          </Col>
        </Row>
        
      </Form>
    </React.Fragment>
  )
}

export default AccessCodeForm 
